/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Assistant_Activity_RunningInputs */



/**
* | output |
* | --- |
* | "Running {tool}..." |
*
* @param {Assistant_Activity_RunningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_activity_running = /** @type {((inputs: Assistant_Activity_RunningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Activity_RunningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Exécution de ${i?.tool}...`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.tool} wird ausgeführt...`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Esecuzione di ${i?.tool}...`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Запуск ${i?.tool}...`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Ejecutando ${i?.tool}...`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`运行${i?.tool}...`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.tool} を実行中...`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.tool} चल रहा है...`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Executando ${i?.tool}...`)
	return /** @type {LocalizedString} */ (`Running ${i?.tool}...`)
});